import { getUrlForDomainInContext } from '@atlaskit/atlassian-context/get-url-for-domain-in-context';
import { isIsolatedCloud } from '@atlaskit/atlassian-context/is-isolated-cloud';
import { addRovoParamsToUrl } from '@atlaskit/rovo-triggers/params';

import { isStaging } from '../env-helpers/index.ts';

const ATLAS_PROD_URL = 'https://home.atlassian.com';
const ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';

export const getAtlasHost = (): string => {
	if (isIsolatedCloud()) {
		return getUrlForDomainInContext('home', 'prod') ?? ATLAS_PROD_URL;
	}

	return isStaging() ? ATLAS_STAGING_URL : ATLAS_PROD_URL;
};

// This is exported as public API for usage by other packages
export const getAtlasURL = (siteId: string, path: string, orgId: string | undefined): string => {
	let argConcat = '?';
	let processedPath = path.startsWith('/') ? path : `/${path}`;

	if (processedPath.includes('?')) {
		argConcat = '&';
	}

	const basePath = orgId ? `${getAtlasHost()}/o/${orgId}` : getAtlasHost();

	return addRovoParamsToUrl(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
		cloudId: siteId,
	});
};
